import { wrapRootElement as wrap } from './root-wrapper';
import './src/styles/global.css';
import 'normalize.css';
// require('prismjs/themes/prism-tomorrow.css');
// require('./src/styles/global.css');
// require('normalize.css');

export const wrapRootElement = wrap;
